import { defineMessages } from 'react-intl';

type MessagesType = {
  [name: string]: { id: string };
};

const messages: MessagesType = defineMessages({
  errorTitle: { id: 'src-modules-auth-onboarding-errortitle' },
  errorDesc: { id: 'src-modules-auth-onboarding-errordesc' },
  titlestep1: { id: 'src-modules-auth-onboarding-titlestep1' },
  descstep1: { id: 'src-modules-auth-onboarding-descstep1' },
  titlestep2: { id: 'src-modules-auth-onboarding-titlestep2' },
  descstep2: { id: 'src-modules-auth-onboarding-descstep2' },
  titlestep3: { id: 'src-modules-auth-onboarding-titlestep3' },
  descstep3: { id: 'src-modules-auth-onboarding-descstep3' },
  slogantitlestepError: { id: 'src-modules-auth-onboarding-slogantitlesteperror' },
  slogandescstepError: { id: 'src-modules-auth-onboarding-slogandescsteperror' },
  slogantitlestep1: { id: 'src-modules-auth-onboarding-slogantitlestep1' },
  slogandescstep1: { id: 'src-modules-auth-onboarding-slogandescstep1' },
  slogantitlestep2: { id: 'src-modules-auth-onboarding-slogantitlestep2' },
  slogandescstep2: { id: 'src-modules-auth-onboarding-slogandescstep2' },
  slogantitlestep3: { id: 'src-modules-auth-onboarding-slogantitlestep3' },
  slogandescstep3: { id: 'src-modules-auth-onboarding-slogandescstep3' },
  continue: { id: 'src-modules-auth-onboarding-continue' },
  saveandsubmit: { id: 'src-modules-auth-onboarding-saveandsubmit' },
  wizardinfo: { id: 'src-modules-auth-onboarding-wizardinfo' },
  required: { id: 'src-modules-auth-onboarding-required' },
  salutationlabel: { id: 'src-modules-auth-onboarding-salutationlabel' },
  salutationoptionmr: { id: 'src-modules-auth-onboarding-salutationoptionmr' },
  salutationoptionmrs: { id: 'src-modules-auth-onboarding-salutationoptionmrs' },
  titlelabel: { id: 'src-modules-auth-onboarding-titlelabel' },
  titleoptionprof: { id: 'src-modules-auth-onboarding-titleoptionprof' },
  titleoptionprofdr: { id: 'src-modules-auth-onboarding-titleoptionprofdr' },
  titleoptiondr: { id: 'src-modules-auth-onboarding-titleoptiondr' },
  firstnamelabel: { id: 'src-modules-auth-onboarding-firstnamelabel' },
  lastnamelabel: { id: 'src-modules-auth-onboarding-lastnamelabel' },
  passwordlabel: { id: 'src-modules-auth-onboarding-passwordlabel' },
  profilenamelabel: { id: 'src-modules-auth-onboarding-profilenamelabel' },
  industrylabel: { id: 'src-modules-auth-onboarding-industrylabel' },
  industrylabelother: { id: 'src-modules-auth-onboarding-industrylabelother' },
  passwordInfo: { id: 'modules-auth-onboarding-passwordInfo' },
  passwordUppercaseCharacter: { id: 'modules-auth-onboarding-passwordUppercaseCharacter' },
  passwordSpecialCharacter: { id: 'modules-auth-onboarding-passwordSpecialCharacter' },
  passwordNumber: { id: 'modules-auth-onboarding-passwordNumber' },
  password10Characters: { id: 'modules-auth-onboarding-password10Characters' },
  noOptionsText: { id: 'noOptionsText' },
  tokenUsed: { id: 'modules-auth-error-tokenUsed' },
  tokenUsedLabel: { id: 'modules-auth-error-tokenUsedLabel' },
  inputLabelFirstName: { id: 'input-label-firstName' },
  inputLabelLastName: { id: 'input-label-lastName' },
  inputLabelPassword: { id: 'input-label-password' },
  inputLabelProfileTitle: { id: 'input-label-profileTitle' },
  inputLabelProfileIndustry: { id: 'input-label-profileIndustry' },
  altImgMail: { id: 'modules-auth-register-altImgMail' },
  passwordTooltipText: { id: 'modules-auth-onboarding-passwordTooltipText' },
});

export const messagesIndustries = defineMessages({
  other: { id: 'src-modules-auth-onboarding-industry-others' },
});

export default messages;
